import { z } from 'zod';
import validations from 'utils/validations';

// Mirrors components/add-entry-modal/services/validate-entry.ts, adapted to
// this local copy's EntryLedgerType (no annuality/months_advanced, has
// mortgageId instead). Every other field is z.any() so it passes through
// instead of being stripped from the resolver's resolved values.
export const createAddEntrySchema = () => z.object({
  entryDate: z.any(),
  description: validations.requiredString('Required'),
  code: z.any(),
  amount: z.any(),
  kind: z.any(),
  letter: z.any(),
  amount_override: z.any(),
  number: z.any(),
  amount_calculated: z.any(),
  months: z.any(),
  mortgageId: z.any(),
});
